import type { SVGProps } from 'react';
const SvgIconArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M7.03 3.58a.75.75 0 1 0-1.06-1.06L1.373 7.116a1.25 1.25 0 0 0 0 1.768L5.97 13.48a.75.75 0 1 0 1.06-1.06L3.775 8.75H14.25a.75.75 0 0 0 0-1.5H3.775z"
    />
  </svg>
);
export default SvgIconArrowLeft;
